import React from 'react';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'

const SuperProButton = () => {
  return (<Button
    variant='contained' color="primary"
    style={{color: '#ffffff', width: '100%'}}
    onClick={() => {
      window.open(
        'https://housecall.typeform.com/to/CyFeKy',
        '_blank'
      )
    }}
  >
    APPLY NOW
  </Button>)
}
export default SuperProButton
